import { FilterIconV2, MenuIconV2 } from "../../../../assets/svgIcons";
import styles from "./styles.module.scss";
import secondaryComponents from "../..";
import { useState } from "react";
import { MoreMenuNav } from "../MoreMenuNav";
import { MenuHeader } from "./MenuHeader";
import { MobileProductFilter } from "../MobileProductFilter";
import { MobileAllCatgories } from "../MobileAllCatgories";

export const MobileMenu = ({
  defaultView,
  pricingType,
  setDefaultView = () => {},
  setPricingType = () => {},
}) => {
  const [views, setView] = useState({
    isfilter: false,
    isMenu: false,
    isCategory: false,
  });
  return (
    <>
      <section className={styles.mobileMenu}>
        <div className={styles.mobileMenu__left}>
          <button
            className={`${styles.button} ${styles.long}`}
            onClick={() => setView((prev) => ({ ...prev, isCategory: true }))}
          >
            <FilterIconV2 />
            <span>Categories</span>
          </button>
        </div>

        <div className={styles.divided}></div>

        <div className={styles.mobileMenu__right}>
          <button
            className={`${styles.button}`}
            onClick={() => setView((prev) => ({ ...prev, isfilter: true }))}
          >
            <FilterIconV2 />
            <span>Filter</span>
          </button>
          <button
            className={`${styles.button}`}
            onClick={() => setView((prev) => ({ ...prev, isMenu: true }))}
          >
            <MenuIconV2 />
            <span>Menu</span>
          </button>
        </div>
      </section>

      <secondaryComponents.Modal
        isActive={views?.isMenu}
        width={700}
        closeModal={() => setView((prev) => ({ ...prev, isMenu: false }))}
        style={{ padding: 0 }}
      >
        <MenuHeader
          title="Menu"
          closeModal={() => setView((prev) => ({ ...prev, isMenu: false }))}
        />
        <MoreMenuNav />
      </secondaryComponents.Modal>

      <secondaryComponents.Modal
        isActive={views?.isfilter}
        width={700}
        closeModal={() => setView((prev) => ({ ...prev, isfilter: false }))}
        style={{ padding: 0 }}
      >
        <MenuHeader
          title="Filter"
          closeModal={() => setView((prev) => ({ ...prev, isfilter: false }))}
        />
        <MobileProductFilter
          pricingType={pricingType}
          setPricingType={setPricingType}
          defaultView={defaultView}
          setDefaultView={setDefaultView}
        />
      </secondaryComponents.Modal>

      <secondaryComponents.Modal
        isActive={views?.isCategory}
        width={700}
        closeModal={() => setView((prev) => ({ ...prev, isCategory: false }))}
        style={{ padding: 0 }}
      >
        <MenuHeader
          title="Categories"
          closeModal={() => setView((prev) => ({ ...prev, isCategory: false }))}
        />
        <MobileAllCatgories
          closeModal={() => setView((prev) => ({ ...prev, isCategory: false }))}
        />
      </secondaryComponents.Modal>
    </>
  );
};
